import CloseIcon from "@mui/icons-material/Close";
import MaskAndValid from "utils/maskAndValid";

export default function PersonalDataForm({
  open,
  onClose,
  nameInput,
  setNameInput,
  cpfInput,
  setCpfInput,
  error,
  onSubmit,
  brandColors,
}) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 60,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: brandColors.surface,
          borderRadius: "8px",
          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
          padding: "24px",
          maxWidth: "400px",
          width: "90%",
          maxHeight: "90vh",
          overflow: "auto",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: brandColors.textMuted,
          }}
          onMouseEnter={(e) => {
            e.target.style.color = brandColors.textBase;
          }}
          onMouseLeave={(e) => {
            e.target.style.color = brandColors.textMuted;
          }}
        >
          <CloseIcon style={{ fontSize: "24px" }} />
        </button>
        <h3
          style={{
            textAlign: "center",
            marginBottom: "24px",
            marginTop: "8px",
          }}
        >
          Preencha seus dados para finalizar a vitrine
        </h3>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "8px" }}>
            Nome *
          </label>
          <input
            type="text"
            value={nameInput}
            onChange={(e) => setNameInput(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: `1px solid ${brandColors.border}`,
            }}
            placeholder="Digite seu nome"
            maxLength={150}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "8px" }}>CPF *</label>
          <input
            type="text"
            value={cpfInput}
            onChange={(e) => setCpfInput(MaskAndValid.maskCPF(e.target.value))}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: `1px solid ${brandColors.border}`,
            }}
            placeholder="Informe seu CPF"
            maxLength={14}
          />
        </div>
        {error && (
          <p style={{ color: "#d32f2f", marginBottom: "16px" }}>{error}</p>
        )}
        <button
          onClick={onSubmit}
          disabled={!cpfInput || !nameInput}
          style={{
            width: "100%",
            padding: "12px",
            background: brandColors.primary,
            color: "#fff",
            border: 0,
            borderRadius: "4px",
            fontWeight: 600,
            fontSize: "16px",
            cursor: "pointer",
            opacity: !cpfInput || !nameInput ? 0.5 : 1,
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => {
            if (cpfInput && nameInput) {
              e.target.style.backgroundColor = brandColors.primaryHover;
            }
          }}
          onMouseLeave={(e) => {
            if (cpfInput && nameInput) {
              e.target.style.backgroundColor = brandColors.primary;
            }
          }}
        >
          Finalizar Vitrine
        </button>
      </div>
    </div>
  );
}
